import { render, staticRenderFns } from "./CommentsTopical.vue?vue&type=template&id=e3dc99b2&scoped=true&"
import script from "./CommentsTopical.vue?vue&type=script&lang=js&"
export * from "./CommentsTopical.vue?vue&type=script&lang=js&"
import style0 from "./CommentsTopical.vue?vue&type=style&index=0&id=e3dc99b2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e3dc99b2",
  null
  
)

export default component.exports